export default __webpack_public_path__ + "static/media/VKOW_11_mos_SAMF.1237d248.wav";